// component
import RouterView from '@/components/router-view.vue';

// rounting
import ProjectRouting from './project/project-routing';
import AccountInfoRouting from './account-info/account-info-routing';
import PurchaseBusinessRouting from './purchase-business/purchase-business-routing';
// import MessageCenterRouting from './message-center/message-center-routing';
import InvoiceProRouting from './invoice-pro/invoice-pro-routing';
import hostingProRouting from './hosting/routing';
import MyAssetsRouting from './my-assets/routing';
import ResourcesAssets from './resources-assets/routing';

export default [
  {
    path: 'project',
    name: 'project',
    component: RouterView,
    redirect: '/person-center/project/roll-out-project/list',
    meta: {
      title: '我的项目',
      breadCrumbShowIndexArr: [1]
    },
    children: ProjectRouting
  },
  {
    path: 'account-info',
    name: 'accountInfo',
    component: RouterView,
    redirect: '/person-center/account-info/member-info',
    meta: {
      title: '账户信息',
      breadCrumbShowIndexArr: [1]
    },
    children: AccountInfoRouting
  },
  {
    path: 'purchase-business',
    name: 'purchaseBusiness',
    component: RouterView,
    redirect: '/person-center/purchase-business/purchase-project/list',
    meta: {
      title: '我的采购业务'
    },
    children: PurchaseBusinessRouting
  },
  // {
  //   path: 'message-center',
  //   name: 'messageCenter',
  //   component: RouterView,
  //   redirect: '/person-center/message-center/notice-list',
  //   meta: {
  //     title: '消息中心'
  //   },
  //   children: MessageCenterRouting
  // },
  {
    path: 'invoice-pro',
    name: 'invoicepro',
    component: RouterView,
    redirect: '/person-center/invoice-pro/list',
    meta: {
      title: '发票管理'
    },
    children: InvoiceProRouting
  },
  {
    path: 'hosting',
    name: 'hosting',
    component: RouterView,
    redirect: '/person-center/hosting/list',
    meta: {
      title: '我的托管业务'
    },
    children: hostingProRouting
  },
  {
    path: 'my-assets',
    name: 'myAssets',
    component: RouterView,
    redirect: '/person-center/my-assets/list',
    meta: {
      title: '我的资产'
    },
    children: MyAssetsRouting
  },
  {
    path: 'resources-assets',
    name: 'ResourcesAssets',
    component: RouterView,
    redirect: '/person-center/my-assets/list',
    meta: {
      title: '资源资产'
    },
    children: ResourcesAssets
  }
];
